module.exports = __webpack_public_path__ + "media/customizations/pecansquarelife/logo-ecef5771a723b0eb232c0fb4629a2db6.png";